// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { selectCategoryReducer, STATE_NAME } from './store/select-category.reducer';
import { SelectCategoryEffects } from './store/select-category.effects';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from '@coa/app/shared/dropdown/dropdown.module';
import { SelectCategoryDropdownComponent } from '@coa/app/shared/filters/select-category/components/select-category-dropdown/select-category-dropdown.component';
import { DropdownOptionsPipeModule } from '@coa/app/shared/dropdown/dropdown-options-pipe/dropdown-options-pipe.module';
import { SelectCategoryFilterComponent } from '@coa/app/shared/filters/select-category/components/select-category-filter/select-category-filter.component';

@NgModule({
  declarations: [
    SelectCategoryDropdownComponent,
    SelectCategoryFilterComponent,
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    TranslateModule.forChild(),
    StoreModule.forFeature(STATE_NAME, selectCategoryReducer),
    EffectsModule.forFeature([SelectCategoryEffects]),
    MatSelectModule,
    ReactiveFormsModule,
    DropdownModule,
    DropdownOptionsPipeModule,
    FormsModule,
  ],
  exports: [
    SelectCategoryDropdownComponent,
    SelectCategoryFilterComponent,
  ],
})
export class SelectCategoryModule {
}
